import { baseServer } from '@/api/api'
export default {
  name: 'getImgUrl',
  methods: {
    getImgUrl (arr, attr = 'url') {
      this.$getUrl({
        name: arr.filter(k => k[attr] !== '').map(e => e[attr]).join()
      }).then(obj => {
        if (obj) {
          arr.forEach((e) => {
            if (e[attr]) {
              this.$set(e, 'imgUrl', obj[e[attr]] || '')
            }
          })
        }
      })
    },
    getMoreImgUrl (allData, dataArr) {
      let nameArr = []
      allData.forEach(e => {
        dataArr.forEach(e1 => {
          if (Array.isArray(e[e1.name])) {
            nameArr = nameArr.concat(e[e1.name].map(e2 => e2[e1.attr]))
          }
        })
      })
      return new Promise((resolve) => {
        baseServer.getImg({
          name: nameArr.join()
        }).then(res => {
          let { code, data } = res
          if (code === '0') {
            if (data) {
              allData.forEach(e => {
                dataArr.forEach(e1 => {
                  if (Array.isArray(e[e1.name])) {
                    e[e1.name].forEach(e2 => {
                      if (e2[e1.attr]) {
                        this.$set(e2, 'imgUrl', data[e2[e1.attr]] || '')
                      }
                    })
                  }
                })
              })
            }
            resolve(data)
          } else {
            resolve({})
          }
        }).catch(() => {
          resolve({})
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getImgUrl.js